import { animate, TargetsParam, utils } from 'animejs'
import { BET_SLIP_BUTTON_ID } from '@core/Areas/AppHeader/Components/MyBetsButtons/Components/BetSlipButton/constants'

/**
 * Make sure to call this in a setTimeout if calling during a react render loop otherwise it will render last loop's dom
 * @param element
 * @returns
 */
export async function animateSelectionButtonToBetslip(element: HTMLButtonElement) {
  const targetEl = document.getElementById(BET_SLIP_BUTTON_ID)
  if (!targetEl || !element) return

  const elementBox = element.getBoundingClientRect()
  const elementCenter = {
    x: elementBox.left + elementBox.width / 2,
    y: elementBox.top + elementBox.height / 2,
  }

  const targetBox = targetEl.getBoundingClientRect()
  const targetCenter = {
    x: targetBox.left + targetBox.width / 2,
    y: targetBox.top + targetBox.height / 2,
  }

  const clonedButton = element.cloneNode(true) as HTMLButtonElement
  document.body.appendChild(clonedButton)

  utils.set(clonedButton, {
    position: 'fixed',
    zIndex: 2,
    top: `${elementBox.top}px`,
    left: `${elementBox.left}px`,
    width: `${element.clientWidth}px`,
    height: `${element.clientHeight}px`,
    background: 'black',
    color: 'white',
  })

  animate(clonedButton as TargetsParam, {
    translateY: [0, targetCenter.y - elementCenter.y],
    translateX: [0, targetCenter.x - elementCenter.x],
    rotate: [0, 45],
    scale: [1, 0.2],
    opacity: { from: 1, to: 0.2 },
    ease: 'inOutQuart',
    duration: 700,
    onComplete: () => clonedButton.remove(),
  })
}
